var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"image-view"},[_c('div',{staticClass:"image-view__header"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('span',{on:{"click":function($event){return _vm.$emit('close')}}},[_c('img',{staticClass:"close",attrs:{"src":require('@/assets/img/close-x.png')}})])]),_c('img',{attrs:{"src":_vm.imageUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }